import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Tag } from 'utils/types';

import c from '../utils/constants';

interface Payload {
  tag: string;
  key: string;
}

export default function useCreateTag() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation<{ data: Tag }, ApiError, Payload, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: '/api/v1/tags',
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/tags`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.TAGS] });

      // toastSuccess('Successfully created new tag.');
    },
  });
}
